import { Menu } from "@mantine/core";
import { ModalComponent } from "components";
import { DeleteMenuItemProps } from "./types";

import { useTableProvider } from "../../provider";
import { useModals } from "@mantine/modals";

export function DeleteMenuItem(props: DeleteMenuItemProps) {
  const { part } = props;

  const modals = useModals();
  const { refreshTable } = useTableProvider();

  function handleClick() {
    modals.openContextModal("spare-part.delete", {
      title: <ModalComponent.Title>Are you sure?</ModalComponent.Title>,
      innerProps: {
        part: part,
        onSubmit: async () => await refreshTable(),
      },
    });
  }

  return <Menu.Item onClick={handleClick}>Delete</Menu.Item>;
}
